import alarmAnalyticsImg from "../assets/common/alarms/alarmAnalytics.svg";
import alarmOperationalImg from "../assets/common/alarms/alarmOperational.svg";
import alarmStrategicImg from "../assets/common/alarms/alarmStrategic.svg";

/**
 * Obtiene la ilustración asociada a la categoría de una alarma.
 * El servicio puede incluir un sufijo de audiencia, por ejemplo Analytics_Trader.
 *
 * @param {string} idTypeAlarm Identificador devuelto por el servicio de alarmas.
 * @returns {string} Ilustración de la categoría de alarma.
 */
export const getAlarmTypeImage = (idTypeAlarm) => {
  const category = String(idTypeAlarm || "").trim().split("_")[0].toLowerCase();

  switch (category) {
    case "analytics":
      return alarmAnalyticsImg;
    case "strategic":
      return alarmStrategicImg;
    case "operational":
    default:
      return alarmOperationalImg;
  }
};
